"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PlusIcon = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var PlusIcon = function PlusIcon(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#PlusIcon_svg__PlusIcon_svg__clip0_20663_110292)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.003,
    cy: 9.003,
    r: 9.003,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.316 2.633a6.5 6.5 0 105.176 6.027h-4.713l-.914 4.344H8.133l.914-4.344H4.966l.344-1.638h4.082l.924-4.389z",
    fill: "url(#PlusIcon_svg__PlusIcon_svg__paint0_radial_20663_110292)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.193 7.022h-4.07l.806-3.826a6.519 6.519 0 013.264 3.826z",
    fill: "url(#PlusIcon_svg__PlusIcon_svg__paint1_radial_20663_110292)"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "PlusIcon_svg__PlusIcon_svg__paint0_radial_20663_110292",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-47.743 18.804 4.944) scale(18.6976 20.7268)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.052,
    stopColor: "#FF5C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.255,
    stopColor: "#EA507C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#B941EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708,
    stopColor: "#5B61FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.938,
    stopColor: "#21BEE7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "PlusIcon_svg__PlusIcon_svg__paint1_radial_20663_110292",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-47.743 18.804 4.944) scale(18.6976 20.7268)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.052,
    stopColor: "#FF5C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.255,
    stopColor: "#EA507C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#B941EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708,
    stopColor: "#5B61FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.938,
    stopColor: "#21BEE7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "PlusIcon_svg__PlusIcon_svg__clip0_20663_110292"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 9,
    fill: "#fff"
  }))));
};

exports.PlusIcon = PlusIcon;
var _default = PlusIcon;
exports.default = _default;